export default __webpack_public_path__ + "static/media/broken-screen.93ab03c5.png";